export default __webpack_public_path__ + "static/media/logo-spotify.d2a3d2d3.svg";